module.exports = __webpack_public_path__ + "static/logo-text-only-dark-ff2f2726210b3040c0470f38b6ef1357.svg";